/**
 * @fileoverview Type definitions for consent management system
 * Defines interfaces for GDPR-compliant cookie consent preferences
 */

/**
 * @typedef {Object} ConsentPreferences
 * @property {boolean} essential - Always true (required for site functionality)
 * @property {boolean} analytics - Google Analytics tracking consent
 * @property {boolean} advertising - AdSense and ad personalization consent
 * @property {number} timestamp - When consent was given (Unix timestamp)
 * @property {string} version - Consent policy version
 * @property {number} expiresAt - Expiry timestamp (12 months from consent)
 */

/**
 * @typedef {Object} ConsentModeState
 * @property {'granted'|'denied'} ad_storage - Ad storage consent state
 * @property {'granted'|'denied'} analytics_storage - Analytics storage consent state
 * @property {'granted'|'denied'} ad_user_data - Ad user data consent state
 * @property {'granted'|'denied'} ad_personalization - Ad personalization consent state
 * @property {'granted'} functionality_storage - Always granted
 * @property {'granted'} security_storage - Always granted
 */

export const CONSENT_VERSION = '1.0';
export const EXPIRY_MONTHS = 12;
export const STORAGE_KEY = 'stockviz_consent_preferences';
